module.exports = __webpack_public_path__ + "img/undraw_customer_survey_f9ur.3ad8a05b.svg";